import { PendingUser, ApprovedUser } from '@/schemas/admin.types';
import * as adminApi from '@/api/adminApi';

export class UserService {
  private static instance: UserService;

  public static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }

  async fetchPendingUsers(): Promise<PendingUser[]> {
    try {
      const users = await adminApi.fetchPendingUsers();

      // Transform backend response to PendingUser type
      const pendingUsers = users.map(user => ({
        id: user.user_id,  // Use backend's user_id field
        email: user.email || '',
        role: user.role || '',
        name: user.name || '',
        created_at: user.created_at || null,
        status: 'pending' as const
      }));

      return pendingUsers;
    } catch (error) {
      console.error('Failed to fetch pending users:', error);
      throw error instanceof Error ? error : new Error('Failed to fetch pending users');
    }
  }

  async fetchApprovedUsers(): Promise<ApprovedUser[]> {
    try {
      const users = await adminApi.fetchApprovedUsers();

      // Transform backend response to ApprovedUser type
      const approvedUsers = users.map(user => ({
        id: user.user_id,  // Use backend's user_id field
        email: user.email || '',
        role: user.role || '',
        name: user.name || '',
        created_at: user.created_at || null,
        approved_at: user.approved_at || null,
        approved_by: user.approved_by || '',
        status: 'approved' as const
      }));

      return approvedUsers;
    } catch (error) {
      console.error('Failed to fetch approved users:', error);
      throw error instanceof Error ? error : new Error('Failed to fetch approved users');
    }
  }

  async approveUser(pendingUser: PendingUser, adminEmail: string): Promise<void> {
    try {
      if (!pendingUser.id) {
        throw new Error('User ID is missing');
      }

      await adminApi.approveUser(pendingUser.id, adminEmail);
    } catch (error) {
      console.error('Failed to approve user:', error);
      throw error instanceof Error ? error : new Error('Failed to approve user');
    }
  }

  async rejectUser(pendingUser: PendingUser): Promise<void> {
    try {
      if (!pendingUser.id) {
        throw new Error('User ID is missing');
      }
            await adminApi.rejectUser(pendingUser.id);
    } catch (error) {
      console.error('Failed to reject user:', error);
      throw error instanceof Error ? error : new Error('Failed to reject user');
    }
  }

  async deleteUser(user_id: string): Promise<void> {
    try {
      // Use backend API instead of direct Firestore delete
      await adminApi.deleteUser(user_id);
    } catch (error) {
      console.error('Failed to delete user:', error);
      throw error instanceof Error ? error : new Error('Failed to delete user');
    }
  }
}
